import { useCallback } from 'react';
import type { SingleGameFragment } from '~/client/components/Game/graphql/SingleGameFragment.generated';
import useAddToRecent from './useAddToRecent';
import useCanStartGameSession from './useCanStartGameSession';
import useStartGameSession from './useStartGameSession';
import type StartSessionProps from '../StartSessionProps';

type Props = { game?: SingleGameFragment };

const useGameSessionHandler = ({ game }: Props) => {
  const addToRecent = useAddToRecent();
  const startGameSession = useStartGameSession();
  const canStartGameSession = useCanStartGameSession();
  const hasFunMode = game?.hasFunMode;
  const gameId = game?.id;

  const startSession = useCallback(
    async ({ isFunMode, inGameCurrency }: StartSessionProps) => {
      if (!gameId || !canStartGameSession(hasFunMode && isFunMode)) {
        return undefined;
      }
      const session = await startGameSession(
        gameId,
        isFunMode,
        inGameCurrency ?? undefined,
      );
      if (session) {
        addToRecent(gameId);
      }
      return session;
    },
    [gameId, hasFunMode, canStartGameSession, startGameSession, addToRecent],
  );

  return startSession;
};

export default useGameSessionHandler;
